export enum LocalserverStatusTableColumnsIdEnum {
    TIME_STOP = "start_date",
    TIME_RESTART = "end_date",
    DURATION = "duration_in_seconds",
}
